import { type MenuActionItem, type MenuItem } from '@shared/menu';

import { SEARCH_JUMP, SEARCH_RECENT } from './search.mock';
import {
  SEARCH_CLEAR_RECENTS,
  SEARCH_GROUP_PREVIEW,
  SEARCH_GROUP_TITLE,
  SEARCH_KIND_ICON,
  SEARCH_KIND_LABEL,
  SEARCH_KIND_ORDER,
  type SearchHit,
  searchViewAllValue,
} from './search.types';

function hitToItem(hit: SearchHit, prefix: string): MenuActionItem {
  const useKindLabel = prefix === 'recent' || !hit.description;

  return {
    value: `${prefix}:${hit.id}`,
    label: hit.title,
    description: useKindLabel ? undefined : hit.description,
    descriptionKey: useKindLabel ? SEARCH_KIND_LABEL[hit.kind] : undefined,
    icon: prefix === 'recent' ? 'clockAlt' : SEARCH_KIND_ICON[hit.kind],
  };
}

export function idleSearchItems(
  recents: readonly SearchHit[] = SEARCH_RECENT,
): readonly MenuItem[] {
  const items: MenuItem[] = [];

  if (recents.length) {
    items.push({
      kind: 'group',
      titleKey: 'header.search.recent',
      actionLabelKey: 'header.search.clear',
      actionValue: SEARCH_CLEAR_RECENTS,
      items: recents.map((hit) => hitToItem(hit, 'recent')),
    });
    items.push({ kind: 'separator' });
  }

  items.push({
    kind: 'group',
    titleKey: 'header.search.jumpTo',
    items: SEARCH_JUMP.map((item) => ({
      value: item.id,
      labelKey: item.labelKey,
      descriptionKey: item.descriptionKey,
      icon: item.icon,
    })),
  });

  return items;
}

export function resultSearchItems(hits: readonly SearchHit[]): readonly MenuItem[] {
  const groups: MenuItem[] = [];

  for (const kind of SEARCH_KIND_ORDER) {
    const groupHits = hits.filter((hit) => hit.kind === kind);
    if (!groupHits.length) continue;

    const count = groupHits.length;
    const showViewAll = count > SEARCH_GROUP_PREVIEW;

    if (groups.length) groups.push({ kind: 'separator' });

    groups.push({
      kind: 'group',
      titleKey: SEARCH_GROUP_TITLE[kind],
      titleParams: { count },
      actionLabelKey: showViewAll ? 'header.search.viewAll' : undefined,
      actionLabelParams: showViewAll ? { count } : undefined,
      actionValue: showViewAll ? searchViewAllValue(kind) : undefined,
      actionIcon: showViewAll ? 'chevronRight' : undefined,
      items: groupHits.slice(0, SEARCH_GROUP_PREVIEW).map((hit) => hitToItem(hit, 'result')),
    });
  }

  return groups;
}

export function focusFirstInput(root: HTMLElement | null | undefined): void {
  root?.querySelector('input')?.focus();
}
